import {objectToCamelCase} from '../utils'

import ReportAPI from './api'
import options from './options'

export default class Report {
  static api = ReportAPI.create(Report)
  static readOnlyFields = ['organization_id']
  static options = options

  constructor({
    organizationId = '',
    startingFundBalance = null,
    onboardedUsers = null,
    onboardedActiveUsers = null,
    onboardedInactiveUsers = null,
    requestsReceived = null,
    requestsProcessing = null,
    requestsFullyApproved = null,
    requestsPartiallyApproved = null,
    requestsPartiallyApprovedPending = null,
    requestsDeclined = null,
    referredRequestsReceived = null,
    referredRequestsFullyApproved = null,
    referredRequestsPartiallyApproved = null,
    referredRequestsDeclined = null,
    amountRequested = null,
    uniqueRequestors = null,
    amountDisbursed = null,
    amountContributed = null,
    uniqueContributors = null,
    fundBalance = null,
    totalApprovedRequests = null,
    organizationContributions = null,
    otherContributions = null,
    creditDebitContributions = null,
    payrollContributions = null,
    uniqueGrantees = null,
    eligibleUsers = null,
    medianOneTimeCardContribution = null,
    activeRecurringCardContributors = null,
    medianActiveRecurringCardContributions = null,
    activePayrollContributors = null,
    medianOneTimePayrollContributions = null,
    oneTimePayrollContributions = null,
    oneTimeCardContributors = null,
    recurringPayrollContributions = null,
    medianRecurringPayrollContributions = null,
    enrolledParticipantsCount = null,
    enrolledParticipantsList = null,
    activeNominatorsCount = null,
    declinedNomineesList = null,
    moneyDueToNominators = null,
    atRiskParticipants = null,
    stipendRequestsReceived = null,
    stipendRequestsDeclined = null,
    numberOfAtRiskParticipants = null,
    requestsCertificated = null,
    requestsClassified = null,
    atRiskParticipantsPast = null,
    incentivePayments = null,
    treatmentPayments = null,
    followUpPayments = null,
  } = {}) {
    Object.assign(this, {
      organizationId,
      startingFundBalance,
      onboardedUsers,
      onboardedActiveUsers,
      onboardedInactiveUsers,
      requestsReceived,
      requestsProcessing,
      requestsFullyApproved,
      requestsPartiallyApproved,
      requestsPartiallyApprovedPending,
      requestsDeclined,
      referredRequestsReceived,
      referredRequestsFullyApproved,
      referredRequestsPartiallyApproved,
      referredRequestsDeclined,
      amountRequested,
      uniqueRequestors,
      amountDisbursed,
      amountContributed,
      uniqueContributors,
      fundBalance,
      totalApprovedRequests,
      organizationContributions,
      otherContributions,
      creditDebitContributions,
      payrollContributions,
      uniqueGrantees,
      eligibleUsers,
      medianOneTimeCardContribution,
      activeRecurringCardContributors,
      medianActiveRecurringCardContributions,
      activePayrollContributors,
      medianOneTimePayrollContributions,
      oneTimePayrollContributions,
      oneTimeCardContributors,
      recurringPayrollContributions,
      medianRecurringPayrollContributions,
      enrolledParticipantsCount,
      enrolledParticipantsList,
      activeNominatorsCount,
      declinedNomineesList,
      moneyDueToNominators,
      atRiskParticipants,
      stipendRequestsReceived,
      stipendRequestsDeclined,
      numberOfAtRiskParticipants,
      requestsCertificated,
      requestsClassified,
      atRiskParticipantsPast,
      incentivePayments,
      treatmentPayments,
      followUpPayments,
    })
  }

  static create(opts = {}) {
    return new Report(opts)
  }

  static fromAPI(json = {}) {
    return new Report(objectToCamelCase(json))
  }
}
